// Axios
import Axios from "./axios";

export const editWorkshop = (workshopId, value) => {
  return new Promise((resolve, reject) => {
    const data = Axios.put(`/academyworkshop/edit/${workshopId}`, value, {
      headers: {
        "access-token": localStorage.getItem("access_token"),
      },
    });
    resolve(data);
  });
};
